import React, { Component } from "react";
import Input from "../../2/Controls/Input";
import NewButton from "../../2/Controls/NewButton";
import Autocompletesearch from "../../2/Controls/Autocompletesearch";

class CustomerFilterStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Component state can be added here if needed
    };
  }

  // Helper methods for updating form data
  updateFormData = (field, value) => {
    this.props.updateFormData(field, value);
  };

  // Handler for customer visit frequency switch
  handleCustomerSwitchChange = (checked) => {
    this.updateFormData("customerSelected", checked);
    this.updateFormData("customerInDays", "");
    this.updateFormData("customerVisited", "");
  };

  // Handler for purchase amount switch
  handlePurchaseAmountSwitchChange = (checked) => {
    this.updateFormData("purchaseAmountSelected", checked);
    this.updateFormData("purchaseAmountFrom", "");
    this.updateFormData("purchaseAmountTo", "");
  };

  // Handler for membership switch
  handleMembershipSwitchChange = (checked) => {
    this.updateFormData("membershipSelected", checked);
    // Clear membership selection when switching off
    if (!checked) {
      this.updateFormData("membership", null);
    }
  };

  // Handler for gender switch
  handleGenderSwitchChange = (checked) => {
    this.updateFormData("customerGenderSelected", checked);
  };

  // Handler for wallet balance switch
  handleWalletBalanceSwitchChange = (checked) => {
    this.updateFormData("walletBalanceSelected", checked);
    this.updateFormData("walletBalanceFrom", "");
    this.updateFormData("walletBalanceTo", "");
  };

  // Handler for outstanding amount switch
  handleOutstandingSwitchChange = (checked) => {
    this.updateFormData("outStandingAmtSelected", checked);
    this.updateFormData("outStandingAmtFrom", "");
    this.updateFormData("outStandingAmtTo", "");
  };

  // Handler for membership selection
  handleMembershipSelect = (item) => {
    let membership = {
      MembershipID: item.key || item.MembershipID,
      Name: item.Name,
    };
    this.updateFormData("membership", membership);
  };

  // Handler for membership input change (when user types)
  handleMembershipInputChange = (value) => {
    // This is called when the input value changes
    // You might want to clear the selected membership when user starts typing
    const currentMembership = this.getPropValue(this.props.formData, 'membership', {});
    if (value !== currentMembership.Name) {
      this.updateFormData("membership", null);
    }
  };

  // Render suggestion for membership autocomplete
  renderSuggestion = (item, index) => (
    <div key={index}>
      <p style={{ margin: 0 }}>{item.Name}</p>
      {item.Description && (
        <small style={{ color: '#666' }}>{item.Description}</small>
      )}
    </div>
  );

  // Safe access method for props
  getPropValue = (obj, prop, defaultValue = null) => {
    return obj && obj.hasOwnProperty(prop) ? obj[prop] : defaultValue;
  };

  // Styles object
  styles = {
   
    title: {
      fontSize: '24px',
      fontWeight: 'bold',
      marginBottom: '24px'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '24px',
      marginBottom: '24px'
    },
    card: {
      border: '1px solid #e5e7eb',
      borderRadius: '8px',
      padding: '16px'
    },
    filterGroup: {
      marginTop: '12px'
    },
    rowWithThreeCols: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '8px',
      alignItems: 'end'
    },
    twoColumnGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '12px',
      marginTop: '12px'
    },
    daysText: {
      fontSize: '14px',
      color: '#4b5563',
      display: 'flex',
      alignItems: 'center'
    },
    buttonWrapper: {
      marginTop: '24px',
      width:"300px"
    },
   
  };

  render() {
    const {
      formData,
      membershipList,
      customerFetching,
      onFetchCustomers,
    } = this.props;

    console.log(formData);

    // Safe access to formData properties using getPropValue
    const customerSelected = this.getPropValue(formData, 'customerSelected', false);
    const customerVisited = this.getPropValue(formData, 'customerVisited', "");
    const customerInDays = this.getPropValue(formData, 'customerInDays', "");
    
    const purchaseAmountSelected = this.getPropValue(formData, 'purchaseAmountSelected', false);
    const purchaseAmountFrom = this.getPropValue(formData, 'purchaseAmountFrom', "");
    const purchaseAmountTo = this.getPropValue(formData, 'purchaseAmountTo', "");
    
    const membershipSelected = this.getPropValue(formData, 'membershipSelected', false);
    const membership = this.getPropValue(formData, 'membership', null);
    
    const customerGenderSelected = this.getPropValue(formData, 'customerGenderSelected', false);
    const customerGender = this.getPropValue(formData, 'customerGender', "");
    
    const walletBalanceSelected = this.getPropValue(formData, 'walletBalanceSelected', false);
    const walletBalanceFrom = this.getPropValue(formData, 'walletBalanceFrom', "");
    const walletBalanceTo = this.getPropValue(formData, 'walletBalanceTo', "");
    
    const outStandingAmtSelected = this.getPropValue(formData, 'outStandingAmtSelected', false);
    const outStandingAmtFrom = this.getPropValue(formData, 'outStandingAmtFrom', "");
    const outStandingAmtTo = this.getPropValue(formData, 'outStandingAmtTo', "");

    // Safe access to membershipList
    const safeMembershipList = formData && formData.hasOwnProperty('membershipList') && Array.isArray(membershipList) 
      ? membershipList 
      : [];

    // Get membership display value for Autocompletesearch
    const membershipDisplayValue = membership && membership.hasOwnProperty('Name') ? membership.Name : "";

    return (
      <div >
        <h2 style={this.styles.title}>Filter Customers</h2>

        <div style={this.styles.grid}>
          {/* Customer Visit Frequency */}
          <div style={this.styles.card}>
            <Input
              type="switch"
              label="Filter By Customer Visit Frequency"
              value={customerSelected}
              onChange={this.handleCustomerSwitchChange}
            />

            {customerSelected && (
              <div style={this.styles.filterGroup}>
                <div style={this.styles.rowWithThreeCols}>
                  <Input
                    type="select"
                    value={customerVisited}
                    onChange={(value) =>
                      this.updateFormData("customerVisited", value)
                    }
                    placeholder="Select"
                  >
                    <option value="Visited">Visited</option>
                    <option value="Not Visited">Not Visited</option>
                  </Input>
                  <Input
                    type="number"
                    placeholder="Days"
                    value={customerInDays}
                    onChange={(value) =>
                      this.updateFormData("customerInDays", value)
                    }
                  />
                  <span style={this.styles.daysText}>days</span>
                </div>
              </div>
            )}
          </div>

          {/* Purchase Amount */}
          <div style={this.styles.card}>
            <Input
              type="switch"
              label="Filter By Customer Purchase Amount"
              value={purchaseAmountSelected}
              onChange={this.handlePurchaseAmountSwitchChange}
            />

            {purchaseAmountSelected && (
              <div style={this.styles.twoColumnGrid}>
                <Input
                  type="number"
                  label="From"
                  value={purchaseAmountFrom}
                  onChange={(value) =>
                    this.updateFormData("purchaseAmountFrom", value)
                  }
                />
                <Input
                  type="number"
                  label="To"
                  value={purchaseAmountTo}
                  onChange={(value) =>
                    this.updateFormData("purchaseAmountTo", value)
                  }
                />
              </div>
            )}
          </div>

          {/* Membership */}
          <div style={this.styles.card}>
            <Input
              type="switch"
              label="Filter By Customer Membership"
              value={membershipSelected}
              onChange={this.handleMembershipSwitchChange}
            />

            {membershipSelected && (
              <div style={this.styles.filterGroup}>
                <Autocompletesearch
                  value={membershipDisplayValue}
                  label="Select Membership"
                  data={safeMembershipList}
                  defaultDataCount={10}
                  filterKey={["Name"]}  // This tells the component to search by Name field
                  onChange={this.handleMembershipInputChange}
                  onSelect={this.handleMembershipSelect}
                  placeholder="Search Membership"
                  showsearch={false}  // Hide search icon inside input
                  renderSuggestion={this.renderSuggestion}
                  // Optional: Add clear button behavior
                  clearInputValueAfterSelect={false}
                />
              </div>
            )}
          </div>

          {/* Gender */}
          <div style={this.styles.card}>
            <Input
              type="switch"
              label="Filter By Customer Gender"
              value={customerGenderSelected}
              onChange={this.handleGenderSwitchChange}
            />

            {customerGenderSelected && (
              <div style={this.styles.filterGroup}>
                <Input
                  type="select"
                  label="Select Gender"
                  value={customerGender}
                  onChange={(value) =>
                    this.updateFormData("customerGender", value)
                  }
                >
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </Input>
              </div>
            )}
          </div>

          {/* Wallet Balance */}
          <div style={this.styles.card}>
            <Input
              type="switch"
              label="Filter By Customer Wallet Amount"
              value={walletBalanceSelected}
              onChange={this.handleWalletBalanceSwitchChange}
            />

            {walletBalanceSelected && (
              <div style={this.styles.twoColumnGrid}>
                <Input
                  type="number"
                  label="From"
                  value={walletBalanceFrom}
                  onChange={(value) =>
                    this.updateFormData("walletBalanceFrom", value)
                  }
                />
                <Input
                  type="number"
                  label="To"
                  value={walletBalanceTo}
                  onChange={(value) =>
                    this.updateFormData("walletBalanceTo", value)
                  }
                />
              </div>
            )}
          </div>

          {/* Outstanding Amount */}
          <div style={this.styles.card}>
            <Input
              type="switch"
              label="Filter By Customer Outstanding Amount"
              value={outStandingAmtSelected}
              onChange={this.handleOutstandingSwitchChange}
            />

            {outStandingAmtSelected && (
              <div style={this.styles.twoColumnGrid}>
                <Input
                  type="number"
                  label="From"
                  value={outStandingAmtFrom}
                  onChange={(value) =>
                    this.updateFormData("outStandingAmtFrom", value)
                  }
                />
                <Input
                  type="number"
                  label="To"
                  value={outStandingAmtTo}
                  onChange={(value) =>
                    this.updateFormData("outStandingAmtTo", value)
                  }
                />
              </div>
            )}
          </div>
        </div>

        <div style={this.styles.buttonWrapper}>
          <NewButton
            type="secondary"
            processing={customerFetching}
            onClick={onFetchCustomers}
            text="Fetch Customers" 
          />
        </div>
      </div>
    );
  }
}

export default CustomerFilterStep;